import { ReactElement } from "react";
import { ListTableColumn, renderEnumValue } from "sprint-common-web";

import { OrderTransferStatus } from "../../orders/common/types/OrderTransferStatus";

export const renderOrderTransferStatus = <T,>(
    item?: T,
    _index?: number,
    column?: ListTableColumn<T>
): ReactElement | null => {
    return renderEnumValue(OrderTransferStatus, item, _index, column);
};
